import React, { useEffect } from "react";
import { IngestorNav } from "./IngestorNav";
import { ScrapeRunDetail } from "./ScrapeRunDetail";
import { RetrieveRunDetail } from "./RetrieveRunDetail";
import { RenderRunDetail } from "./RenderRunDetail";
import { DispatchRunDetail } from "./DispatchRunDetail";
import { ingestionActions } from "../../actions";
import { connect } from "react-redux";

function IngestionRunDetail(props) {
  const { ingestion, getIngestionRunDetail } = props;
  const run_id = Number(props.match.params.id);
  const run = ingestion?.run;

  useEffect(() => {
    getIngestionRunDetail(run_id);
  }, [run_id]);

  function runTypeDetail(run) {
    switch (run?.ingestion_run_type) {
      case "scrape":
        return <ScrapeRunDetail run={run} />;
      case "render":
        return <RenderRunDetail run={run} />;
      case "dispatch":
        return <DispatchRunDetail run={run} />;
      case "retrieve":
        return <RetrieveRunDetail run={run} />;
      default:
        return;
    }
  }

  return (
    <>
      <br />

      <div class="refresh"></div>
      <div class="searchMain">
        <div class="contentContainerLeftNav">
          <div class="leftNav">
            <IngestorNav parent="overview" />
          </div>
          <div class="rightContent">{runTypeDetail(run)}</div>
        </div>
      </div>
    </>
  );
}
function mapStateToProps(state) {
  const { org, ingestion } = state;
  return {
    org,
    ingestion,
  };
}

const actionCreators = {
  getIngestionRunDetail: ingestionActions.getIngestionRunDetail,
};

const connectedIngestionRunDetail = connect(
  mapStateToProps,
  actionCreators
)(IngestionRunDetail);
export { connectedIngestionRunDetail as IngestionRunDetail };
